import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class Dlt645Data {
  constructor () {
    instance = instance || this

    this._table = DB.dlt645Data

    return instance
  }

  /**
   * @param [number] options.dlt645DeviceId
   * @param [string] options.dataId
   *
   * @returns [number] device id
   */
  async add (options) {
    return this._table.add({
      id: newGuid(),
      dlt645DeviceId: options.dlt645DeviceId,
      dataId: options.dataId
    })
  }

  async get (id) {
    return this._table.get({ id })
  }

  async all () {
    return this._table.toArray()
  }

  async update (id, data) {
    return this._table.update(id, {
      dataId: data.dataId
    })
  }

  async delete (id) {
    return this._table.delete(id)
  }

  async dlt645Id (id) {
    return this._table.where({ dlt645DeviceId: id }).toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/dlt645-data.js